import { useContext } from "react";
import { Link as RouterLink } from 'react-router-dom';
import { Table, TableBody, TableCell, TableFooter, TableHead, TableRow, Link, Typography, Chip } from "@mui/material";
import { customersSummaryContext } from '../CustomersSummaryContext';
import { useIntl } from "react-intl";
import { LocalizationIds } from 'helpers/Localizations';
import Moment from 'react-moment';
import { SummaryActuality } from "helpers/Enums";
import theme from "assets";

let Results = () => {
    let { formatMessage } = useIntl();
    let service = useContext(customersSummaryContext);


    let getStatusChipColor = (actuality: SummaryActuality) => {
        switch (actuality) {
            case SummaryActuality.Past:
                return theme.palette.grey[500];

            case SummaryActuality.Present:
                return theme.palette.primary.main;

            case SummaryActuality.Future:
                return theme.palette.info.main;

            default:
                return theme.palette.grey[500];
        }
    }

    return (
        <>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>{formatMessage({ id: LocalizationIds.DateFrom })}</TableCell>
                        <TableCell>{formatMessage({ id: LocalizationIds.DateTo })}</TableCell>
                        <TableCell>{formatMessage({ id: LocalizationIds.Status })}</TableCell>
                        <TableCell>{formatMessage({ id: LocalizationIds.Technician })}</TableCell>
                        <TableCell>{formatMessage({ id: LocalizationIds.Customer })}</TableCell>
                        <TableCell>{formatMessage({ id: LocalizationIds.Ticket })}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {service.summaries && service.summaries.map((summary, index) =>
                        <TableRow hover key={index}>
                            <TableCell>
                                <Moment date={summary.startDate} format="DD/MM/YYYY" />
                            </TableCell>
                            <TableCell>
                                <Moment date={summary.endDate} format="DD/MM/YYYY" />
                            </TableCell>
                            <TableCell>
                                <Chip
                                    label={formatMessage({ id: 'SummaryActuality' + summary.actuality })}
                                    variant="outlined"
                                    style={{
                                        color: getStatusChipColor(summary.actuality),
                                        borderColor: getStatusChipColor(summary.actuality)
                                    }}
                                />
                            </TableCell>
                            <TableCell>{summary.userDisplayName}</TableCell>
                            <TableCell>
                                <Link target="_blank" href={`${process.env.REACT_APP_CRM_URL}/contact/${summary.customerId}`}>
                                    {summary.customerName}&nbsp;-&nbsp;{summary.countryName}
                                </Link>
                            </TableCell>
                            <TableCell>
                                <Link component={RouterLink} to={`/ticket/edit/${summary.ticketNumber}`}>
                                    {summary.ticketNumber}
                                </Link>&nbsp;-&nbsp;{summary.ticketTitle}
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                {service.summaries?.length === 0 &&
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={7}>
                                <Typography variant="subtitle2">{formatMessage({ id: LocalizationIds.NoDataFound })}</Typography>
                            </TableCell>
                        </TableRow>
                    </TableFooter>
                }
            </Table>
            {/* <TablePagination
                component="div"
                count={service.recordCount}
                onPageChange={service.handleChangePage}
                page={service.search.pageNr}
                rowsPerPage={service.search.pageSize}
                rowsPerPageOptions={[service.search.pageSize]}
                labelDisplayedRows={({ page, count }) =>
                    <>
                        {formatMessage({ id: LocalizationIds.TotalTickets })}:&nbsp;{service.recordCount} &nbsp;&middot;&nbsp;
                        {formatMessage(
                            { id: LocalizationIds.PageOf },
                            { pageNr: page + 1, count: Math.ceil(count / service.search.pageSize) }
                        )}
                    </>
                }
            /> */}
        </>
    )
}

export default Results;